import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import ArrowRight from '../../../../../components/icons/ArrowRight';
import PhoneInput from '../../../../../components/global/PhoneInput';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onLoginViaEmail: PropTypes.func,
};

const PhoneForm = ({
  values,
  handleSubmit,
  handleChange,
  loading,
  onLoginViaEmail,
}) => {
  return (
    <Fragment>
      <h4 className="text-center mb-2">
        Please verify your mobile number to access this gallery
      </h4>
      <p className="mb-4">We&apos;ll send you a verification PIN code!</p>
      <form
        onSubmit={handleSubmit}
        className="w-100 px-0 px-md-6 d-flex flex-column align-items-center"
      >
        <PhoneInput
          id="phone_number"
          label=""
          value={values.phone_number || '+1'}
          onChange={phone =>
            handleChange({
              target: {
                name: 'phone_number',
                value: phone,
              },
            })
          }
          className="w-100 mb-0"
          autoFocus
        />
        <Button
          type="submit"
          className="mt-2 mb-4"
          btnBlock
          disabled={loading || values.phone_number === '+1'}
        >
          {loading ? 'Sending...' : 'Send PIN Code'}
        </Button>
      </form>
      <p className="text-center mb-0">
        By continuing you agree to the{' '}
        <a
          className="d-block"
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use &amp; Conditions
        </a>
      </p>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
        Can&apos;t receive a US SMS message?{' '}
        <Button
          btnStyle="reset"
          className="ml-0 ml-md-2 mt-1 mt-md-0 d-flex align-items-center text-primary text-extra-bold"
          onClick={() => onLoginViaEmail()}
        >
          Authenticate with email{' '}
          <ArrowRight color="#0d84fe" className="ml-1" size={15} />
        </Button>{' '}
      </div>
    </Fragment>
  );
};

PhoneForm.propTypes = propTypes;

export default PhoneForm;
